var React = require('react');

function IconStarSmallFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.386.233l1.419 3.77 3.832.233c.164.016.276.113.335.292.06.179.023.33-.111.455L8.9 7.563l.938 3.839a.389.389 0 0 1-.162.426c-.145.105-.292.118-.441.04l-3.23-2.03-3.262 2.112c-.15.078-.296.065-.442-.04a.389.389 0 0 1-.162-.426l.939-3.84-2.961-2.59a.588.588 0 0 1-.095-.514c.048-.187.17-.288.363-.304l3.822-.233 1.43-3.77A.385.385 0 0 1 6.01 0c.175 0 .3.078.375.233z","fill":"currentColor","fillRule":"evenodd"}));
}

IconStarSmallFilled.defaultProps = {"width":"12","height":"12"};

module.exports = IconStarSmallFilled;

IconStarSmallFilled.default = IconStarSmallFilled;
